// @flow

import type { Action } from './store.type';

type AttentivesSuccess = {
  data: any
};

type AttentiveFailure = {
  error: any
};

/* #region: Get klaviyo status */
export const GET_ATTENTIVE_STATUS_REQUEST = 'GET_ATTENTIVE_STATUS_REQUEST';
type GET_ATTENTIVE_STATUS_REQUEST_TYPE = 'GET_ATTENTIVE_STATUS_REQUEST';

export const GET_ATTENTIVE_STATUS_SUCCESS = 'GET_ATTENTIVE_STATUS_SUCCESS';
type GET_ATTENTIVE_STATUS_SUCCESS_TYPE = 'GET_ATTENTIVE_STATUS_SUCCESS';

export const GET_ATTENTIVE_STATUS_FAILURE = 'GET_ATTENTIVE_STATUS_FAILURE';
type GET_ATTENTIVE_STATUS_FAILURE_TYPE = 'GET_ATTENTIVE_STATUS_FAILURE';

type GetAttentiveStatusRequestAction = Action<GET_ATTENTIVE_STATUS_REQUEST_TYPE, null>;

type GetAttentiveStatusSuccessAction = Action<GET_ATTENTIVE_STATUS_SUCCESS_TYPE, AttentivesSuccess>;

type GetAttentiveStatusFailureAction = Action<GET_ATTENTIVE_STATUS_FAILURE_TYPE, AttentiveFailure>;
/* #endregion */

/* #region: Generate klaviyo link  */
export const GENERATE_ATTENTIVE_LINK_REQUEST = 'GENERATE_ATTENTIVE_LINK_REQUEST';
type GENERATE_ATTENTIVE_LINK_REQUEST_TYPE = 'GENERATE_ATTENTIVE_LINK_REQUEST';

export const GENERATE_ATTENTIVE_LINK_SUCCESS = 'GENERATE_ATTENTIVE_LINK_SUCCESS';
type GENERATE_ATTENTIVE_LINK_SUCCESS_TYPE = 'GENERATE_ATTENTIVE_LINK_SUCCESS';

export const GENERATE_ATTENTIVE_LINK_FAILURE = 'GENERATE_ATTENTIVE_LINK_FAILURE';
type GENERATE_ATTENTIVE_LINK_FAILURE_TYPE = 'GENERATE_ATTENTIVE_LINK_FAILURE';

type GenerateAttentiveLinkAction = Action<GENERATE_ATTENTIVE_LINK_REQUEST_TYPE, null>;

type GenerateAttentiveLinkSuccessAction = Action<GENERATE_ATTENTIVE_LINK_SUCCESS_TYPE, AttentivesSuccess>;

type GenerateAttentiveLinkFailureAction = Action<GENERATE_ATTENTIVE_LINK_FAILURE_TYPE, AttentiveFailure>;
/* #endregion */

/* #region: Toggle klaviyo  */
export const TOGGLE_ATTENTIVE_REQUEST = 'TOGGLE_ATTENTIVE_REQUEST';
type TOGGLE_ATTENTIVE_REQUEST_TYPE = 'TOGGLE_ATTENTIVE_REQUEST';

export const TOGGLE_ATTENTIVE_SUCCESS = 'TOGGLE_ATTENTIVE_SUCCESS';
type TOGGLE_ATTENTIVE_SUCCESS_TYPE = 'TOGGLE_ATTENTIVE_SUCCESS';

export const TOGGLE_ATTENTIVE_FAILURE = 'TOGGLE_ATTENTIVE_FAILURE';
type TOGGLE_ATTENTIVE_FAILURE_TYPE = 'TOGGLE_ATTENTIVE_FAILURE';

type ToggleAttentiveAction = Action<TOGGLE_ATTENTIVE_REQUEST_TYPE, null>;

type ToggleAttentiveSuccessAction = Action<TOGGLE_ATTENTIVE_SUCCESS_TYPE, AttentivesSuccess>;

type ToggleAttentiveFailureAction = Action<TOGGLE_ATTENTIVE_FAILURE_TYPE, AttentiveFailure>;
/* #endregion */

export const ATTENTIVE_STATUS = {
  VERIFYING: 'verifying',
  ACTIVE: 'active',
  REMOVED: 'removed',
  INACTIVE: 'inactive'
};

// Action and State
export type AttentiveAction =
  | GetAttentiveStatusRequestAction
  | GetAttentiveStatusSuccessAction
  | GetAttentiveStatusFailureAction
  | GenerateAttentiveLinkAction
  | GenerateAttentiveLinkSuccessAction
  | GenerateAttentiveLinkFailureAction
  | ToggleAttentiveAction
  | ToggleAttentiveSuccessAction
  | ToggleAttentiveFailureAction;